﻿import * as angular from "angular";

import DataService from "../Services/DataService";

interface RecoverModel {
    passwordValidationResult: number[];
    password?: {
        passwordMinLength: number;
        passwordIncludeUpperLetter: boolean;
        passwordIncludeLowerLetter: boolean;
        passwordIncludeNumber: boolean;
        passwordIncludeSpecial: boolean;
        passwordExcludeNames: boolean;
    };
    inputOldPassword?: string;
    inputPassword1?: string;
    inputPassword2?: string;
}

interface RecoverActions {
    isPasswordValid: () => Promise<void>;
    doPasswordsMatch: () => void;
    doResetPasswordsMatch: () => void;
    recover: ($event: Event) => void;
}

interface RecoverScope extends angular.IScope {
    model: RecoverModel;
    actions: RecoverActions;
}

class RecoverController {
    private $scope: RecoverScope;
    private $rootScope: angular.IRootScopeService;
    private dataService: DataService;

    private _frame: HTMLElement | null;

    constructor(
        $scope: RecoverScope,
        $rootScope: angular.IRootScopeService,
        dataService: DataService,
    ) {
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.dataService = dataService;

        this._frame = document.querySelector<HTMLElement>(".login-frame");

        $scope.model = {
            inputOldPassword: "",
            inputPassword1: "",
            inputPassword2: "",
            passwordValidationResult: [-1],
        };

        $scope.actions = {
            isPasswordValid: this.isPasswordValid.bind(this),
            doPasswordsMatch: this.doPasswordsMatch.bind(this),
            doResetPasswordsMatch: this.doResetPasswordsMatch.bind(this),
            recover: this.recover.bind(this),
        };

        this.loadData();
    }

    private async loadData() {
        let result = await this.dataService.settings(
            document.location.href.substr(
                document.location.href.lastIndexOf("/") + 1,
            ),
        );

        result = !result || isNaN(Number(result)) ? 180031 : Number(result);
        var chars = Math.floor(result / 10000);
        var raw = result - chars * 10000;

        this.$scope.model.password = {
            passwordMinLength: chars,
            passwordIncludeUpperLetter: (Math.pow(2, 0) & raw) > 0,
            passwordIncludeLowerLetter: (Math.pow(2, 1) & raw) > 0,
            passwordIncludeNumber: (Math.pow(2, 2) & raw) > 0,
            passwordIncludeSpecial: (Math.pow(2, 3) & raw) > 0,
            passwordExcludeNames: (Math.pow(2, 4) & raw) > 0,
        };

        if (!this.$rootScope.$$phase) this.$scope.$apply();
    }

    private async isPasswordValid() {
        if (this.$scope.model.inputPassword1!.length > 2) {
            let result = await this.dataService.validatePassword(
                document.location.href.substr(
                    document.location.href.lastIndexOf("/") + 1,
                ),
                this.$scope.model.inputPassword1!,
            );

            this.$scope.model.passwordValidationResult = result;
            if (
                this.$scope.model.inputPassword1!.length > 0 &&
                this.$scope.model.inputPassword1 !==
                    this.$scope.model.inputPassword2
            )
                this.$scope.model.passwordValidationResult.push(100);

            if (!this.$rootScope.$$phase) this.$scope.$apply();
        }
    }

    private doPasswordsMatch() {
        if (
            this.$scope.model.inputPassword1 !==
            this.$scope.model.inputPassword2
        )
            this.$scope.model.passwordValidationResult.push(100);
        else
            this.$scope.model.passwordValidationResult =
                this.$scope.model.passwordValidationResult.filter(
                    x => x !== 100,
                );
        if (!this.$rootScope.$$phase) this.$scope.$apply();
    }

    private doResetPasswordsMatch() {
        if (
            this.$scope.model.inputPassword1 !== "" &&
            this.$scope.model.inputPassword1 !==
                this.$scope.model.inputPassword2 &&
            !this.$scope.model.passwordValidationResult.includes(100)
        )
            this.$scope.model.passwordValidationResult.push(100);
        else {
            this.$scope.model.passwordValidationResult =
                this.$scope.model.passwordValidationResult.filter(
                    a => a !== 100,
                );
        }
        if (!this.$rootScope.$$phase) this.$scope.$apply();
    }

    recover($event: Event) {
        $event.preventDefault();

        this._frame!.style.height = this._frame!.offsetHeight + "px";
        this._frame?.classList.add("loading");
        this._frame!.style.height = "200px";

        setTimeout(() => {
            document.forms[0].submit();
        }, 700);
    }
}

angular
    .module("datastore")
    .controller("RecoverController", [
        "$scope",
        "$rootScope",
        "dataService",
        RecoverController,
    ]);

export default RecoverController;
